import "../../styles/support-hint.css";

const supportPhone = "09176427900";

const SupportHint = ({
  text = "نیاز به راهنمایی دارید؟",
  className = "",
  tone = "neutral"
}) => {
  return (
    <div className={`support-hint support-hint-${tone} ${className}`} dir="rtl">
      <span>{text}</span>
      <div>
        <a href="/contact">فرم تماس با ما</a>
        <span>یا</span>
        <a href={`tel:${supportPhone}`}>{supportPhone}</a>
      </div>
    </div>
  );
};

export default SupportHint;
